import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_materials_by_project_excl_material_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_id: number, full_text_search?: string, excluded_material_id?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_id: number, full_text_search?: string, excluded_material_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_id: number, full_text_search?: string, excluded_material_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_id: number, full_text_search?: string, excluded_material_id?: number    }) {
        if(isNil($inParams.project_id)) {
          return true; 
        }
      return false;
    }
}
